package br.com.vvrefeicoes.portal.data.repository

import br.com.vvrefeicoes.portal.domain.repository.CepAddress
import br.com.vvrefeicoes.portal.domain.repository.CepRepository
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.http.isSuccess
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

class RemoteCepRepository(
    private val httpClient: HttpClient,
) : CepRepository {
    override suspend fun lookup(cep: String): CepAddress? {
        val response = httpClient.get("https://viacep.com.br/ws/${cep.filter(Char::isDigit)}/json/")
        if (!response.status.isSuccess()) return null
        val dto = response.body<CepDto>()
        if (dto.error) return null
        return CepAddress(
            street = dto.street,
            neighborhood = dto.neighborhood,
            city = dto.city,
            state = dto.state,
        )
    }
}

@Serializable
private data class CepDto(
    @SerialName("logradouro")
    val street: String = "",
    @SerialName("bairro")
    val neighborhood: String = "",
    @SerialName("localidade")
    val city: String = "",
    @SerialName("uf")
    val state: String = "",
    @SerialName("erro")
    val error: Boolean = false,
)
